import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AppThemeProvider } from './lib/theme'
import { ToastProvider } from './components/ds-zta'
import { DialogProvider } from './components/dialogs/DialogProvider'
import { ToastBridge } from './lib/toast'
// The d2d faces (cascade plan 3.4), bundled so they resolve under the /zta/ base.
// index.css names them: --font-inter-face, --font-geist-mono, --font-plus-jakarta.
import '@fontsource-variable/inter'
import '@fontsource-variable/geist-mono'
import '@fontsource/plus-jakarta-sans/500.css'
import './index.css'

// /__ds, the design-system gallery (cascade plan 2.6). `import.meta.env.DEV` is a
// build-time constant, so a production build drops both the branch and the lazy
// chunk. It mounts here, outside App, because App renders nothing until the tenant
// check passes.
const isGallery =
  import.meta.env.DEV &&
  window.location.pathname.replace(/\/$/, '') === `${import.meta.env.BASE_URL}__ds`
const DsGallery = isGallery ? lazy(() => import('./pages/DsGallery')) : null

// AppThemeProvider (lib/theme.tsx, d2d-XDR's) owns the theme: it follows the OS
// by default, keeps an explicit choice under "d2d-theme", and writes data-ds-mode,
// which index.html's pre-paint script has already set for the first frame.
// One ToastProvider for the whole app (cascade plan 4.4); ToastBridge connects
// lib/toast's toast.success / toast.error to it. DialogProvider gives useDialogs().
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppThemeProvider>
      <ToastProvider>
        <ToastBridge />
        <DialogProvider>
          {DsGallery ? (
            <Suspense fallback={null}>
              <DsGallery />
            </Suspense>
          ) : (
            <App />
          )}
        </DialogProvider>
      </ToastProvider>
    </AppThemeProvider>
  </React.StrictMode>,
)
